// User documents (legacy UserForm "files" block): repeatable { name, file } rows,
// submitted as files[i][name] / files[i][file]; existing media are listed as links.
import { Box, Button, IconButton, Stack, TextField, Typography } from '@mui/material';
import { DocumentUpload, Trash } from 'iconsax-reactjs';

import { t } from '../../i18n';

type FileRow = { name: string; file: File | null };

export function UserFilesWidget({ value, form, onChange }: { value: unknown; form: Record<string, unknown>; onChange: (value: unknown) => void }) {
  const rows: FileRow[] = Array.isArray(value) ? (value as FileRow[]) : [];
  const media = Array.isArray(form.media) ? (form.media as Array<Record<string, unknown>>) : [];
  const update = (index: number, patch: Partial<FileRow>) => onChange(rows.map((row, i) => (i === index ? { ...row, ...patch } : row)));

  return (
    <Stack spacing={1.25}>
      <Typography variant="body2" color="text.secondary">
        {t('field.files')}
      </Typography>
      {media.length ? (
        <Stack spacing={0.5}>
          {media.map((item, index) => {
            const href = String(item.original_url ?? item.url ?? '');
            const label = String(item.name ?? item.file_name ?? href);
            return (
              <Typography key={String(item.uuid ?? item.id ?? index)} variant="caption">
                {href ? (
                  <a href={href} target="_blank" rel="noreferrer">
                    {label}
                  </a>
                ) : (
                  label
                )}
              </Typography>
            );
          })}
        </Stack>
      ) : null}
      {rows.map((row, index) => (
        <Stack key={index} direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ sm: 'center' }}>
          <TextField size="small" label={t('parties.fileName')} value={row.name} onChange={(e) => update(index, { name: e.target.value })} sx={{ flex: 1 }} />
          <Button component="label" size="small" variant="outlined" startIcon={<DocumentUpload size={16} />}>
            {t('action.chooseFile')}
            <input hidden type="file" onChange={(e) => update(index, { file: e.target.files?.[0] ?? null })} />
          </Button>
          <Box sx={{ minWidth: 120 }}>
            <Typography variant="caption">{row.file ? row.file.name : ''}</Typography>
          </Box>
          <IconButton size="small" color="error" onClick={() => onChange(rows.filter((_, i) => i !== index))}>
            <Trash size={16} />
          </IconButton>
        </Stack>
      ))}
      <Box>
        <Button size="small" onClick={() => onChange([...rows, { name: '', file: null }])}>
          {t('parties.addFile')}
        </Button>
      </Box>
    </Stack>
  );
}
